import { render, staticRenderFns } from "./SecurityBehavior.vue?vue&type=template&id=5b5f3afe&scoped=true&"
import script from "./SecurityBehavior.vue?vue&type=script&lang=js&"
export * from "./SecurityBehavior.vue?vue&type=script&lang=js&"
import style0 from "./SecurityBehavior.vue?vue&type=style&index=0&id=5b5f3afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f3afe",
  null
  
)

export default component.exports